import { ReuseButton } from "../ui";
import { ButtonsColorType, ButtonsType } from "../../types/enums";
import { PlusIcon } from "../images";
import { useAddToTargetedListMutation } from "../../api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomToast } from "../ui/CustomToast";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { CircularProgress } from "@mui/material";

type Props = {
  ids: string[];
  successHandler: (ids: string[]) => void;
  fullWidth?: boolean;
  isDemo?: boolean;
};

export const AddToTargetedListBtn = ({
  ids,
  successHandler,
  fullWidth = false,
  isDemo,
}: Props) => {
  const { campaign_id } = useParams();
  const [addToTargetedList, { isLoading }] = useAddToTargetedListMutation();

  const addToTargetedListHandler = () => {
    if (!campaign_id) return;
    addToTargetedList({ campaign_id, ids })
      .unwrap()
      .then(() => successHandler(ids))
      .catch((err) =>
        toast.error(
          <CustomToast
            type="error"
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title="Failed to Add"
          />,
        ),
      );
  };

  const isDisabled = isLoading || ids.length === 0 || isDemo;

  return (
    <ReuseButton
      onClick={addToTargetedListHandler}
      buttonType={ButtonsType.contained}
      buttonColor={ButtonsColorType.blue_white}
      startIcon={
        isLoading ? (
          <CircularProgress size={20} color={"inherit"} />
        ) : (
          <PlusIcon color={isDisabled ? "#BCBCBC" : "white"} />
        )
      }
      fullWidth={fullWidth}
      disabled={isDisabled}
    >
      Add to Targeted List {ids.length > 1 && ` (${ids.length})`}
    </ReuseButton>
  );
};
